<template>
  <div class="client-view">
    <card>
      <h4 class="card-title">Información básica del usuario</h4>
      <form @submit.prevent="" spellcheck="false">
        <div class="inputs">
          <div class="input-left">
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" :class="validStyleField(userInfo.Email)" required v-model="userInfo.Email" id="email" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" />
              <small class="password-no-valid" v-if="!isValidEmail">El formato de email debe ser: email@proveedor.com</small>
            </div>
            <div class="form-group">
              <label for="passwor">Contraseña</label>
              <input type="password" :class="validStyleField(userInfo.Password)" autocomplete="new-password" required v-model="userInfo.Password" @keyup="()=>{confirmPassword()}" id="UserPassword" />
            </div>
            <div class="form-group">
              <label for="passwordConfirm">Confirmar contraseña</label>
              <input type="password" :class="validStyleField(passwordConfirm)" required @keyup="(e)=> {passwordConfirm = e.target.value; confirmPassword()}" id="passwordConfirm" />
            </div>
            
          </div>
          <div class="input-right">
            <div class="form-group">
              <label for="userName">Usuario</label>
              <input type="text" :class="validStyleField(userInfo.UserName)" spellcheck="false" required v-model="userInfo.UserName" id="UserName" />
            </div>
            <div class="form-group">
              <label for="clientName">Rol</label>
              <select v-model="userInfo.Role" name="select">
                <option value="Consulting" selected>Consultor</option>
                <option value="Administrator">Administrator</option>
              </select>
            </div>
            <div class="center">
              <button class="btn btn-primary" type="submit" @click="saveUserInfo">GUARDAR</button>
            </div>
          </div>
        </div>
        <small class="password-no-valid" v-if="!isPasswordValidated">Las contraseñas no coinciden</small>
        <small class="password-no-valid" v-if="isFieldBlank">Los campos no pueden estar vacios</small>
        
      </form>
    </card>
  </div>
</template>
<script>
// import FgInput from "@/components/Inputs/Input.vue";
import userService from "../../services/Fase2/profile";
import Swal from "sweetalert2";
export default {
  name: "create-user",
  data() {
    return {
      userId: "",
      isFieldBlank: false,
      isValidEmail: true,
      passwordConfirm: "",
      isPasswordValidated: true,
      userInfo: {
        BusinessUnitId: 1,
        Email: "",
        Password: "",
        Role: "Consulting",
        SubscrId: "0",
        UserId: "",
        UserName: ""
      },
      UserInfoUpdate: {
        UserName: "",
        Email: "",
        Status: true
      },
      UserPasswordUpdate:{
        Password: "",
      }
    };
  },
  async created() {
    this.$store.commit("FillClient", "");
    const businessUnitId = localStorage.getItem("businessUnitId");
    this.userInfo.BusinessUnitId = businessUnitId;
    this.userInfo.SubscrId = '0';

  },
  async updated(){
    
      const {Email,Password,Role,UserName} = this.userInfo;
      const isValid = Email ? Role ? UserName ? this.passwordConfirm ? Password ? true : false : false : false : false : false;
      if(isValid){
          this.isFieldBlank = false;
          // this.isValidEmail = true;
          // this.isPasswordValidated = true;
          // return false;
      }
      const email = document.getElementById("email");
      email.addEventListener('change',()=>{
        this.isValidEmail = true;
      })
      // else{
      //   this.isFieldBlank = false;
      // }
  },
  methods:{
    saveUserInfo: async function(){
      try{
        
        const formValidated = this.validFrom();
        

        if(formValidated){
          this.isFieldBlank = false;
          this.isPasswordValidated = true;
          const status = await new userService(this).createUser(this.userInfo);
          
          if(status){
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Usuario Registrado Satisfactoriamente",
              showConfirmButton: false,
              timer: 1500
            });
            document.getElementById("passwordConfirm").value = "";
            this.userInfo = {
              BusinessUnitId: 1,
              Email: "",
              Password: "",
              Role: "",
              SubscrId: '0',
              UserId: "",
              UserName: ""
            }
          }else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Usuario o Email ya existen",
              showConfirmButton: false,
              timer: 1500
            });
          }
          
          
        }

      }catch(e){
        console.log(e);
      }
    },
    validStyleField: function(property){
      
      return this.isFieldBlank ? property ? 'field-valid': 'field-blank' : '';
    },
    validFrom: function(){
      const {Email,Password,Role,UserName} = this.userInfo;
      const validEmail = RegExp("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[a-zA-Z]{2,4}$").test(Email);
      const isValid = Email ? Role ? UserName ? this.passwordConfirm ? true : false : false : false : false;
      const isValidPassword = Password ? Password == this.passwordConfirm ? true : false : false;
      this.isPasswordValidated = true;
      this.isFieldBlank = false;

      if(!isValid){
          this.isFieldBlank = true;
          this.isPasswordValidated = true;
          return false;
      }

      if(!isValidPassword){
          this.isPasswordValidated = false;
          this.isFieldBlank = false;
          return false
      }

      if(!validEmail){
        this.isValidEmail = false;
        return false
      }

      return true
    },
    fillUserInfoUpdate: function(e,property){
      let value = e.target.value;
      this.UserInfoUpdate[property] = value;
    },
    fillUserPasswordUpdate: function(e){
      let value = e.target.value;
      this.UserPasswordUpdate.Password = value;
    },
    confirmPassword: function(){
      let password = this.userInfo.Password;
        let passConfirmation = this.passwordConfirm;
        const isValidated = password
        ? password == passConfirmation ? true : false 
        : false;
        this.isPasswordValidated = isValidated;
        return isValidated
    },
    validEmail: function(){

    }
  }
  // components: {
  //   FgInput
  // }
};
</script>
<style lang="scss" scoped>
.client-view {
  max-width: 1000px;
  margin: 0 auto;
  .card-title {
    margin-bottom: 10px;
  }
}
.password-no-valid{
  color: red;
  display: block;
  margin: 10px 0;
}
[readonly], [disabled]{
  background-color: #f6f6f6;
  color: #797979;
  border-color: #c8c8c8;
}
select{
    font-size: 16px;
}
.field-blank{
  border: 1.5px solid red;
}
.field-valid{
  border: 1.5px solid dodgerblue;
}
.center{
  margin-top: 40px;
}

@include respond-above(md) {
  .inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
}
</style>